import $ from 'jquery';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { compose, pure, withProps } from 'recompose';
import logo from '../../../common/images/logo_tikeasy_white.png';
import {
  ALMANAC,
  CALENDAR,
  CONTENT,
  DAILY_NEWS,
  EMAG,
  FICTION,
  FLEET,
  GROUPED_ORDER,
  HOME,
  NOTIFICATION,
  PARTNER_ACCOUNT,
  PARTNER_PROFILE,
  STATISTIC,
  USER,
} from '../../../routes/Pages';
import { withPage, withSelectedLink } from '../../helper';
import Link from '../../Link';
import s from './MenuBar.module.css';

const MenuEntry = ({ partnerNumber, page }) => (
  <li>
    <Link to={`/${partnerNumber}${page.pageURL}`}>
      <FormattedMessage
        id={`/${partnerNumber}${page.pageURL}`}
        defaultMessage={page.pageTitle}
      />
    </Link>
  </li>
);

const MenuGroupPure = ({
  partnerNumber,
  name,
  glyphicon,
  currentPage,
  pages,
}) => (
  <li className={pages && pages.indexOf(currentPage) > -1 ? 'active' : ''}>
    <Link to={`/${partnerNumber}${pages[0].pageURL}`}>
      <span className={`glyphicon ${glyphicon}`} />
      <span className={`sidemenu-label ${s.sideMenuLabel}`}>{name}</span>
    </Link>
    <ul className={`nested-dropdown animated fadeIn ${s.nestedDropdown}`}>
      <li className={`sidemenu-header ${s.sideMenuHeader}`}>{name}</li>
      {pages.map((page) => (
        <MenuEntry
          key={page.pageURL}
          partnerNumber={partnerNumber}
          page={page}
        />
      ))}
    </ul>
  </li>
);

const MenuGroup = compose(pure)(MenuGroupPure);

const MenuBarPure = ({ partnerNumber, currentPage, entries }) => (
  <div className={`side-menu ${s.sideMenu}`}>
    <div className={`menu-body ${s.menuBody}`}>
      <ul
        className={`nav nav-pills nav-stacked no-margin ${s.sidenav}`}
        onClick={() => $('.dashboard-page').toggleClass('push-right')}
      >
        {entries.map((entry) => (
          <MenuGroup
            key={entry.name}
            partnerNumber={partnerNumber}
            currentPage={currentPage}
            {...entry}
          />
        ))}
      </ul>
      <img
        className={`menu-logo ${s.menuLogo}`}
        src={logo}
        alt="Tikeasy"
        height="30"
      />
    </div>
  </div>
);

const menuList = [
  { name: 'Accueil', glyphicon: 'glyphicon-home', pages: [HOME] },
  {
    name: 'Administration',
    glyphicon: 'glyphicon-cog',
    pages: [PARTNER_ACCOUNT, GROUPED_ORDER],
  },
  { name: 'Gestion du parc', glyphicon: 'glyphicon-phone', pages: [FLEET] },
  {
    name: 'Gestion des contenus',
    glyphicon: 'glyphicon-folder-open',
    pages: [CONTENT, NOTIFICATION, ALMANAC, DAILY_NEWS, FICTION, EMAG],
  },
  { name: 'Calendrier', glyphicon: 'glyphicon-calendar', pages: [CALENDAR] },
  { name: 'Utilisateurs', glyphicon: 'glyphicon-user', pages: [USER] },
  { name: 'Partenaire', glyphicon: 'glyphicon-tags', pages: [PARTNER_PROFILE] },
  { name: 'Statistiques', glyphicon: 'glyphicon-stats', pages: [STATISTIC] },
];

const filteredMenuList = (props) =>
  menuList
    .map((entry) => ({
      ...entry,
      pages: entry.pages.filter((page) => page.isVisible(props)),
    }))
    .filter(({ pages }) => pages.length > 0);

const MenuBar = compose(
  withSelectedLink,
  withPage,
  withProps((props) => ({ entries: filteredMenuList(props) })),
  pure,
)(MenuBarPure);

export default MenuBar;
